import {NumberFormatValues, NumericFormat} from 'react-number-format';
import React, {ReactNode} from "react";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {FloatingPortal} from "@floating-ui/react";

export interface NumericFormatOptions {
    isAllowed?: (values: NumberFormatValues) => boolean,

    thousandSeparator?: boolean | string;
    decimalSeparator?: string;
    allowedDecimalSeparators?: Array<string>;
    thousandsGroupStyle?: 'thousand' | 'lakh' | 'wan' | 'none';
    decimalScale?: number;
    fixedDecimalScale?: boolean;
    allowNegative?: boolean;
    allowLeadingZeros?: boolean;
    suffix?: string;
    prefix?: string;
}

interface InputCleave2Props<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>> {
    control: Control<TFieldValues>,
    name: TName,
    label?: string,
    labelClassName?: string,
    icon?: ReactNode,
    className?: string,
    data?: TFieldValues[]
    isLoading?: boolean
    options: NumericFormatOptions,
    disabled?: boolean,
    readOnly?: boolean,
    placeholder?: string,
    rules?: Omit<RegisterOptions<TFieldValues, TName>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>,
    onChange?: (v: any) => void,
    errorPortalId?: string,
    valueAsNumber?: boolean
}

/**
 * InputCleave implementata attraverso NumericFormat
 * https://s-yadav.github.io/react-number-format/docs/intro
 */

export function InputCleave2<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>>({
                                                                                                                                    labelClassName = '',
                                                                                                                                    ...props
                                                                                                                                }: InputCleave2Props<TFieldValues, TName>) {
    return <>
        <Controller<TFieldValues, TName> name={props.name}
                                         control={props.control}
                                         rules={props.rules}
                                         render={({field: {value, onChange}, fieldState}) => {
                                             //('valore da db ', value);
                                             const errorMsg = fieldState.error ? (fieldState.error ? fieldState.error?.message : '') as string : '';
                                             const errorMsgElement = errorMsg ? <p className="text-rose-700">{errorMsg}</p> : null;
                                             //console.log('errorMsg: ', errorMsg);
                                             const simpleLabel =
                                                 props.label ? <label htmlFor={props.name}
                                                                      className={`block text-sm font-medium mb-1 ${props.disabled && 'opacity-70'} ${props.readOnly && 'opacity-70'} ${labelClassName || ''}`}>
                                                     {props.label}
                                                 </label> : null;
                                             const label = simpleLabel && props.icon ? <span className="inline-flex space-x-0.5">{simpleLabel}{props.icon}</span> : simpleLabel;

                                             return <>
                                                 {label}
                                                 <NumericFormat
                                                     {...props.options}
                                                     id={props.name}
                                                     onValueChange={(v) => {
                                                         const value = props.valueAsNumber ? Number.parseFloat(v.value) : v.value;
                                                         onChange(value);
                                                         if (props.onChange)
                                                             props.onChange(value);
                                                     }}
                                                     value={value}
                                                     className={`appearance-none block w-full px-3 border rounded-md disabled:opacity-50 read-only:opacity-70 read-only:bg-sky-50
                                                shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm
                                                ${fieldState.error ? 'border-rose-700' : 'border-gray-300'} ${props.className}`}
                                                     disabled={props.disabled}
                                                     readOnly={props.readOnly}
                                                     placeholder={props.placeholder}
                                                 />

                                                 {/*
                            N.B. per aver la certezza del funzionamento di FloatingPortal viene consigliato di mettere in condizione in portal stesso!
                            https://github.com/floating-ui/floating-ui/issues/2454
                            */}
                                                 {props.errorPortalId && errorMsgElement && <FloatingPortal id={props.errorPortalId}>
                                                     {errorMsgElement}
                                                 </FloatingPortal>}
                                                 {!props.errorPortalId && errorMsg && <p className="text-rose-700 text-balance">{errorMsg}</p>}
                                             </>
                                         }}
        /></>
}